import Utils from '../../framework/utils.js';
import { Loader } from '@googlemaps/js-api-loader';
import DataEvent from '../../framework/data-event.js';
import Globals from '../../framework/globals.js';
import WFGlobals from '../../../../core/scripts/globals.js';

// MapView
// =======
//
// Handles map display, marker generation, and interactions

class MapView extends EventTarget {
  constructor(tmpl, model) {
    super();
    Utils.bindMethods(this, ['onGMapsLoad', 'onMarkerClick', 'onFlyoutCloseClick', 'onLocationCtaClick', 'onWindowResize', 'onFlyoutTransitionEnd']);

    this.dom = tmpl;
    this.markers = [];
    this.locationIds = [];
    this.loader = new Loader({
      apiKey: model.get('gmapsApiKey'),
      version: 'weekly',
      libraries: ['geometry']
    })
    this.loader.load().then(() => {
      return this.onGMapsLoad(model)
    })
    this.dom.querySelector('.map_flyout .close').addEventListener('click', this.onFlyoutCloseClick)
    this.dom.querySelector('.map_flyout').addEventListener('transitionend', this.onFlyoutTransitionEnd);
    this.dom.querySelector('.careers-map_flyout_location-cta').addEventListener('click', this.onLocationCtaClick);

    window.addEventListener('resize', this.onWindowResize);
  }

  // `onGMapsLoad(model)`
  //
  // Once we have the API loaded up, generate the map and create markers
  onGMapsLoad(model) {
    let zooms = {
      lg: 4,
      md: 3,
      sm: 2
    }
    this.map = new google.maps.Map(this.dom.querySelector('.map_map'), {
      center: { lat: 39.8283, lng: -98.5795 }, // centerish of USA
      zoom: (window.innerWidth <  WFGlobals.breakpoints.sm ? zooms.sm : (window.innerWidth < WFGlobals.breakpoints.md ? zooms.md : zooms.lg))
    });
    this.markers=[];
    model.get('mapLocations').forEach((loc) => {
      if (!loc.get('latitude') || !loc.get('longitude')) return;

      let markerId = loc.get('id');
      let marker = new google.maps.Marker({
        position: {
          lat: loc.get('latitude'),
          lng: loc.get('longitude')
        },
        map: this.map,
        title: loc.get('types') ? loc.get('types').join(', ') : null,
        icon: {
          url: window.theme_path + '/frontend/dist/images/icons/location-icon.png',
          size: new google.maps.Size(34, 49),
          origin: new google.maps.Point(0,0),
          anchor: new google.maps.Point(17, 49),
          labelOrigin: new google.maps.Point(17, 17),
        }
      });
      marker.data = loc;
      marker.addListener('click', this.onMarkerClick(marker))

      this.markers.push({
        id: markerId,
        marker: marker
      });

      // Force filter call since map can asynchronously load after filter is applied
      this.onFilter(this.locationIds);
    });
  }

  // `onMarkerClick(marker)`
  //
  // Returns an event handler; this is a necessary step to allow the click handler access to the Marker itself

  onMarkerClick(marker) {
    return (evt) => {
      // Recenter the map
      this.map.panTo(marker.position);

      // Update flyout content and display
      this.dom.querySelector('.careers-map_flyout_location-type').innerHTML = marker.data.get('types').join(', ');
      this.dom.querySelector('.careers-map_flyout_location-address').innerHTML = `${marker.data.get('address')}<br/>${marker.data.get('city')}, ${marker.data.get('region')} ${marker.data.get('postal_code')} ${marker.data.get('country').toUpperCase()}`;
      this.dom.querySelector('.careers-map_flyout_location-cta').setAttribute('data-target', marker.data.toJobLocationModel().get('id'));
      this.dom.querySelector('.map_flyout').classList.remove('d-none');
      window.requestAnimationFrame(() => {
        this.dom.querySelector('.map_flyout').classList.add('show');
      });

      // adjust spacing for mobile flyout
      this.dom.style.paddingBottom = this.dom.querySelector('.map_flyout').getBoundingClientRect().height + 'px';
    }
  }

  onFlyoutCloseClick(evt) {
    this.dom.querySelector('.map_flyout').classList.remove('show');
    this.dom.querySelector('.careers-map_flyout_location-cta').setAttribute('data-target', null);
    this.dom.style.paddingBottom = 0;
  }

  onFlyoutTransitionEnd(evt) {
    if (!evt.currentTarget.classList.contains('show')) {
      this.dom.querySelector('.careers-map_flyout_location-address').innerHTML = '';
      evt.currentTarget.classList.add('d-none');
    }
  }

  onLocationCtaClick(evt) {
    evt.preventDefault();
    this.dispatchEvent(new DataEvent(MapView.Events.LOCATION_REQUEST, {
      location_id: evt.currentTarget.getAttribute('data-target')
    }));
    return false;
  }

  onWindowResize(evt) {
    // make sure we adjust appropriately if the user resizes their window past the breakpoint
    if (this.dom.querySelector('.map_flyout.show'))
      this.dom.style.paddingBottom = this.dom.querySelector('.map_flyout').getBoundingClientRect().height + 'px';
  }

  onFilter(locationIds) {
    // Only show markers with the location IDs
    this.locationIds = locationIds;
    this.markers.forEach(marker => {
      if (locationIds.includes(marker.id)) {
        marker.marker.setMap(this.map); // show the marker
      } else {
        marker.marker.setMap(null); // hide the marker
      }
    });
  }
}

MapView.Events = {
  LOCATION_REQUEST: 'MapView.LocationRequest'
}

export default MapView;